import {
  Moon,
  HeartPulse,
  Activity,
  Footprints,
  BatteryCharging,
  Thermometer,
} from "lucide-react";

export const WEARABLE_DATA = [
  {
    icon: Moon,
    title: "Sleep",
    body: "Deep, REM, total — every night.",
    image: "https://customer-assets.emergentagent.com/job_integrated-wellness-6/artifacts/ykkfy3u8_YplGj6VNPDw55x8L.png",
  },
  {
    icon: HeartPulse,
    title: "Heart Rate & HRV",
    body: "Resting, active, and your bounce-back signal.",
    image: "https://customer-assets.emergentagent.com/job_integrated-wellness-6/artifacts/182e4l7v_PnhPefA2sbp60gUQ.png",
  },
  {
    icon: BatteryCharging,
    title: "Recovery",
    body: "How ready you are today — every morning.",
    image: "https://customer-assets.emergentagent.com/job_integrated-wellness-6/artifacts/pqn2geu6_VxPDS_A4Bt6NaqkY_sk_s.png",
  },
  {
    icon: Footprints,
    title: "Activity",
    body: "Steps, workouts, and movement that counts.",
    image: "https://customer-assets.emergentagent.com/job_integrated-wellness-6/artifacts/k37g4fqd_PnhPefA2sbp60gUQ.png",
  },
  {
    icon: Activity,
    title: "Stress & Strain",
    body: "When you're pushing too hard — before you crash.",
    image: "https://customer-assets.emergentagent.com/job_integrated-wellness-6/artifacts/mn0remsp_dashboard.png",
  },
  {
    icon: Thermometer,
    title: "Body Temp & More",
    body: "Plus glucose, breathing, and the metrics your device tracks.",
    image: "https://customer-assets.emergentagent.com/job_integrated-wellness-6/artifacts/wtrz0ob7_YOZs3eHsBPm0zXfG.png",
  },
];

export const WEARABLES = ["Apple Health", "Oura", "Whoop", "Fitbit", "Garmin"];

export const PATENT_ENGINES = [
  {
    n: "01",
    title: "Body Signal Engine",
    img: "https://customer-assets.emergentagent.com/job_integrated-matrix/artifacts/14v3cjjh_site%203.avif",
  },
  {
    n: "02",
    title: "Heart & Brain Wave Reader",
    img: "https://customer-assets.emergentagent.com/job_integrated-matrix/artifacts/dqgwuc03_cwzF_-SGb3NVE3V9mrgYZ.png",
  },
  {
    n: "03",
    title: "Light Scan Engine",
    img: "https://customer-assets.emergentagent.com/job_integrated-matrix/artifacts/aoz69at7_site%204.avif",
  },
  {
    n: "04",
    title: "Body Composition Reader",
    img: "https://customer-assets.emergentagent.com/job_integrated-matrix/artifacts/oufr22gi_m46fb05y_tckDQ7XIFUwYtjoTpkSlh.png",
  },
  {
    n: "05",
    title: "Biological Age 2.0",
    img: "https://customer-assets.emergentagent.com/job_integrated-matrix/artifacts/8b55qi9i_CqJfRge9P4wotqxdzdH_k.png",
  },
  {
    n: "06",
    title: "Calm & Recovery Console",
    img: "https://customer-assets.emergentagent.com/job_integrated-matrix/artifacts/ytf7sar2_BLS%20Engine.png",
  },
];

export const MAIN_SITE_URL = "https://integratednycai.com/";
export const MATRIX_HERO_IMG =
  "https://customer-assets.emergentagent.com/job_integrated-matrix/artifacts/dpzplyzo_siIMr_wEQXtE6wi1joqDg.png";
